export default __webpack_public_path__ + "static/media/sitefinity.b9c81c9f.svg";